import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  firstName: string;
  lastName: string;
  dob: string;
  email: string;
  phone?: string;
};

export type CreateCustomerResponse = {
  data: {
    id: number;
    existingCustomer: boolean;
    standardEarnings: boolean;
  };
};

export type CreateCustomerErrorBody = {
  errors?: Record<string, string> | string[];
};

// Throws the raw AxiosError so callers can read field-level 422 errors
// ({ errors: { email, phone } }) and surface them inline on the form.
export const useCreateCustomer = createMutation<
  CreateCustomerResponse,
  Variables,
  AxiosError<CreateCustomerErrorBody>
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/internal/partners/organizations/customers',
      method: 'POST',
      data: {
        first_name: variables.firstName,
        last_name: variables.lastName,
        dob: variables.dob,
        email: variables.email,
        phone: variables.phone,
      },
    }).then((response) => response.data),
});
